import { render } from "./SelectTypeComponent.vue?vue&type=template&id=6580df1d&scoped=true"
import script from "./SelectTypeComponent.vue?vue&type=script&lang=js"
export * from "./SelectTypeComponent.vue?vue&type=script&lang=js"

import "./SelectTypeComponent.vue?vue&type=style&index=0&id=6580df1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6580df1d"]])

export default __exports__